export const MultipartUpload = async (
    url: string,
    data: FormData,
    headers?: Headers
): Promise<Response> => {
    if (!headers) {
        headers = new Headers({ Accept: "application/json" });
    }

    const token = localStorage.getItem("swatim_token");
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }

    return fetch(url, {
        method: "POST",
        body: data,
        headers,
    });
};

export default MultipartUpload;
